import { render, staticRenderFns } from "./FundamentalFormDetail.vue?vue&type=template&id=099cbd61&scoped=true&"
import script from "./FundamentalFormDetail.vue?vue&type=script&lang=js&"
export * from "./FundamentalFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./FundamentalFormDetail.vue?vue&type=style&index=0&id=099cbd61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099cbd61",
  null
  
)

export default component.exports